import {
  Checkbox,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormGroup,
  FormControlLabel
} from '@mui/material';
import './MultipleChoicePreview.css';

const MultipleChoicePreview = ({ question, templateType = {} }) => {
  const { options = [] } = question;
  const { value = '' } = templateType;

  return (
    <>
      <Box className='multiple-choice_preview'>
        {value === 'survey' ? (
          <Box>
            <FormGroup>
              {options.map((option) => (
                <FormControlLabel
                  key={option?.value}
                  control={
                    <Checkbox
                      style={{ color: '#00000099' }}
                      inputProps={{
                        'aria-label': option?.option || ''
                      }}
                    />
                  }
                  label={option?.option || ''}
                />
              ))}
            </FormGroup>
          </Box>
        ) : (
          <Box sx={{ minWidth: 200 }}>
            <FormControl style={{ width: 220 }}>
              <InputLabel htmlFor='multiple-choice-options'>
                <span className='preview__input-label'>Answer</span>
              </InputLabel>
              <Select
                className='text-disabled select-disabled'
                defaultValue='none'
                inputProps={{
                  name: 'answer',
                  id: 'multiple-choice-options'
                }}
                disabled
                variant='standard'
              >
                <MenuItem value='none' disabled>
                  Select answer
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>
    </>
  );
};

export default MultipleChoicePreview;
